module.exports = __webpack_public_path__ + "img/ticket_caisse.5cc5c7d4.png";